import script from "./editPlant.vue?vue&type=script&setup=true&lang=js"
export * from "./editPlant.vue?vue&type=script&setup=true&lang=js"

import "./editPlant.vue?vue&type=style&index=0&id=3d412c74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d412c74"]])

export default __exports__